import FilterRegister from "../../../../components/filter/register-basic";
import reqInstagramPosts from "../../../../services/reqMultiTenant/reqInstagramPosts";

import { RegisterProvider } from "../../register-matrix/context-api";
import MainRegisterMatrix from "../../register-matrix/main";
import FormWhatsApp from "../form";

const MainRegisterInstagramDM = () => {
	const options = {
		id: "id_post", //usado para saber qual field usar para atualizar
		ident: "instagramDMConnect", //usado para definir os event listners
		identFilter: "filterInstagramDM", //usado para definir os event listners
		title: "Automatizar DM Instagram",
		subTitle: "Cadastro",
		tableColumns: [
			{ key: "mensagem_dm", label: "Retorno na DM", align: "left", width: "250px" },
			{ key: "triggers", label: "Gatilho", align: "left", width: "250px" },
			{ key: "ativo", label: "Ativo", align: "left", format: "badgeAtivo" },
			{ key: "actions", label: "", align: "right" },
		],
		hasActive: true,
		parametersFilter: [{ id: 1, label: "Gatilho", value: "mensagem_gatilho" }],
	};

	//#region Funções de acesso a dados do componente
	const fetch = async (filterData, newPage) => {
		const { param, paramValue, active } = filterData; //contem active que retorna true ou false

		const responseComplement = await reqInstagramPosts.listPaginateDM(param, paramValue, active, newPage);

		return responseComplement;
	};

	const fetchID = async (currentId) => {
		const responseComplement = await reqInstagramPosts.listID(currentId);

		return responseComplement;
	};

	const insert = async (data) => {
		const response = await reqInstagramPosts.insert(data);

		return response;
	};

	return (
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert}>
			<MainRegisterMatrix FormComponent={FormWhatsApp} FormFilter={FilterRegister} />
		</RegisterProvider>
	);
};

export default MainRegisterInstagramDM;
